export default "//cloud.imgsmail.ru/cloud.mail.ru/146512/img/build/aside-promo-modal/kaspersky-cover.jpg";